import { render, staticRenderFns } from "./ExpenseItemsAdd.vue?vue&type=template&id=1ab7d713"
import script from "./ExpenseItemsAdd.vue?vue&type=script&lang=js"
export * from "./ExpenseItemsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports